import Vue from "vue";
import Router from "vue-router";

// 解决动态路由报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, resolve, reject) {
  if (resolve || reject)
    return originalPush.call(this, location, resolve, reject);
  return originalPush.call(this, location).catch(e => {});
};

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/

export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true
  },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: {
          title: "首页",
          icon: "home"
        }
      }
    ]
  }
];

export const asyncRouterMap = [
  // 信息管理
  {
    path: "/archive-manage",
    component: Layout,
    name: "archive-manage",
    redirect: "/archive-manage/children-archive",
    meta: {
      title: "信息管理",
      icon: "archiveManage",
      permission: "archiveManage.*"
    },
    children: [
      {
        path: "children-archive",
        name: "children-archive",
        component: () =>
          import("@/views/archiveManage/childrenArchive/index.vue"),
        meta: {
          title: "宝宝信息",
          icon: "childrenArchive",
          permission: "childrenArchive.*"
        }
      },
      {
        path: "family-archive",
        name: "family-archive",
        component: () =>
          import("@/views/archiveManage/familyArchive/index.vue"),
        meta: {
          title: "家庭信息",
          icon: "familyArchive",
          permission: "familyArchive.*"
        }
      },
      {
        path: "archive-config",
        name: "archive-config",
        component: () =>
          import("@/views/archiveManage/archiveConfig/index.vue"),
        meta: {
          title: "信息配置",
          icon: "archiveConfig",
          permission: "archiveConfig.*"
        }
      },
      {
        path: "work-spaces",
        name: "work-spaces",
        component: () =>
          import("@/views/archiveManage/childrenArchive/workSpace.vue"),
        meta: {
          title: "评估指导",
          icon: "home",
          permission: "childrenArchive.*"
        },
        hidden: true
      }
    ]
  },

  // 工作台
  {
    path: "/work-platform",
    component: Layout,
    name: "workPlatform",
    redirect: "/work-platform/work-space",
    meta: {
      title: "评估指导",
      icon: "workPlatform",
      permission: "workPlatform.*"
    },
    children: [
      {
        path: "work-space",
        name: "work-space",
        component: () =>
          import("@/views/workPlatform/workSpace2/index.three.vue"),
        meta: {
          title: "评估指导",
          icon: "workSpace",
          permission: "workSpace.*"
        }
      }
    ]
  },

  // 信息统计
  {
    path: "/report-static",
    component: Layout,
    name: "report-static",
    redirect: "/report-static/children-static",
    meta: {
      title: "信息统计",
      icon: "reportStatic",
      permission: "reportStatic.*"
    },
    children: [
      {
        path: "children-static",
        name: "children-static",
        component: () =>
          import("@/views/reportStatic/childrenStatic/index.vue"),
        meta: {
          title: "宝宝统计",
          icon: "childrenStatic",
          permission: "childrenStatic.*"
        }
      },
      {
        path: "evaluate-static",
        name: "evaluate-static",
        component: () =>
          import("@/views/reportStatic/evaluateStatic/index.vue"),
        meta: {
          title: "评估统计",
          icon: "evaluateStatic",
          permission: "evaluateStatic.*"
        }
      }
    ]
  },

  // 内容管理
  {
    path: "/content-management",
    component: Layout,
    name: "content-management",
    redirect: "/content-management/graphic-content",
    meta: {
      title: "内容管理",
      icon: "contentManagement",
      permission: "contentManagement.*"
    },
    children: [
      //图文内容
      {
        path: "graphic-content",
        name: "graphic-content",
        component: () =>
          import("@/views/contentManagement/graphicContent/index.vue"),
        meta: {
          title: "图文知识",
          icon: "graphicContent",
          permission: "graphicContent.*"
        }
      },
      {
        path: "graphic-create-details",
        name: "graphic-create-details",
        component: () =>
          import("@/views/contentManagement/graphicContent/createDetails.vue"),
        meta: {
          title: "图文知识",
          icon: "home"
        },
        hidden: true
      },
      // 音频内容
      {
        path: "audio-content",
        name: "audio-content",
        component: () =>
          import("@/views/contentManagement/audioContent/index.vue"),
        meta: {
          title: "音频知识",
          icon: "audioContent",
          permission: "audioContent.*"
        }
      },
      {
        path: "audio-create-details",
        name: "audio-create-details",
        component: () =>
          import("@/views/contentManagement/audioContent/createDetails.vue"),
        meta: {
          title: "音频知识",
          icon: "home"
        },
        hidden: true
      },
      // 视频内容
      {
        path: "video-content",
        name: "video-content",
        component: () =>
          import("@/views/contentManagement/videoContent/index.vue"),
        meta: {
          title: "视频知识",
          icon: "videoContent",
          permission: "videoContent.*"
        }
      },
      {
        path: "video-create-details",
        name: "video-create-details",
        component: () =>
          import("@/views/contentManagement/videoContent/createDetails.vue"),
        meta: {
          title: "视频知识",
          icon: "home"
        },
        hidden: true
      },
      // 平台知识库
      {
        path: "platform-knowledge-base",
        name: "platform-knowledge-base",
        component: () =>
          import("@/views/contentManagement/platformKnowledgeBase/index.vue"),
        meta: {
          title: "共享知识库",
          icon: "platformKnowledgeBase",
          permission: "platformKnowledgeBase.*"
        }
      },
      {
        path: "guidance-content",
        name: "guidance-content",
        component: () =>
          import("@/views/interventionGuidance/guidanceContent/index.vue"),
        meta: {
          title: "指导库",
          icon: "guidanceContent",
          permission: "guidanceContent.*"
        }
      },
      {
        path: "task-list",
        name: "task-list",
        component: () => import("@/views/taskManagement/taskList/index.vue"),
        meta: {
          title: "任务库",
          icon: "taskList",
          permission: "taskList.*"
        }
      },
      {
        path: "hospital-warehouse",
        name: "hospital-warehouse",
        component: () => import("@/views/formList/hospitalWarehouse/index.vue"),
        meta: {
          title: "量表库",
          icon: "hospitalWarehouse",
          permission: "hospitalWarehouse.*"
        }
      }
    ]
  },

  // 育儿学校
  {
    path: "/course-manage",
    component: Layout,
    name: "course-manage",
    redirect: "/course-manage/face-crouse",
    meta: {
      title: "育儿学校",
      icon: "courseManage",
      permission: "courseManage.*"
    },
    children: [
      {
        path: "face-crouse",
        name: "face-crouse",
        component: () => import("@/views/courseManage/faceCrouse/index.vue"),
        meta: {
          title: "面授课程",
          icon: "faceCrouse",
          permission: "faceCrouse.*"
        }
      },
      {
        path: "classroom-manage",
        name: "classroom-manage",
        component: () =>
          import("@/views/courseManage/classroomManage/index.vue"),
        meta: {
          title: "教室管理",
          icon: "classroomManage",
          permission: "classroomManage.*"
        }
      },
      {
        path: "schedule-manage",
        name: "schedule-manage",
        component: () =>
          import("@/views/courseManage/scheduleManage/index.vue"),
        meta: {
          title: "排课管理",
          icon: "scheduleManage",
          permission: "scheduleManage.*"
        }
      },
      {
        path: "live-streaming-manage",
        name: "live-streaming-manage",
        component: () =>
          import("@/views/courseManage/liveStreamingManage/index.vue"),
        meta: {
          title: "直播课程",
          icon: "liveStreamingManage",
          permission: "liveStreamingManage.*"
        }
      },
      {
        path: "video-courses-manage",
        name: "video-courses-manage",
        component: () =>
          import("@/views/courseManage/videoCoursesManage/index.vue"),
        meta: {
          title: "视频课程",
          icon: "videoCoursesManage",
          permission: "videoCoursesManage.*"
        }
      },
      {
        path: "teacher-manage",
        name: "teacher-manage",
        component: () => import("@/views/courseManage/teacherManage/index.vue"),
        meta: {
          title: "讲师管理",
          icon: "teacherManage",
          permission: "teacherManage.*"
        }
      },
      {
        path: "video-courses-detail",
        name: "video-courses-detail",
        component: () =>
          import("@/views/courseManage/videoCoursesManage/detail.vue"),
        meta: {
          title: "视频课程详情",
          icon: "home"
        },
        hidden: true
      },
      {
        path: "video-courses-directory",
        name: "video-courses-directory",
        component: () =>
          import("@/views/courseManage/videoCoursesManage/setDirectory.vue"),
        meta: {
          title: "设置目录",
          icon: "home"
        },
        hidden: true
      },
      {
        path: "live-streaming-detail",
        name: "live-streaming-detail",
        component: () =>
          import("@/views/courseManage/liveStreamingManage/detail.vue"),
        meta: {
          title: "直播详情",
          icon: "home"
        },
        hidden: true
      },
      {
        path: "live-streaming-appointment-record",
        name: "live-streaming-appointment-record",
        component: () =>
          import(
            "@/views/courseManage/liveStreamingManage/appointmentRecord.vue"
          ),
        meta: {
          title: "预约记录",
          icon: "home"
        },
        hidden: true
      },
      {
        path: "booking-record",
        name: "booking-record",
        component: () =>
          import("@/views/courseManage/scheduleManage/bookingRecord.vue"),
        meta: {
          title: "预约记录",
          icon: "scheduleManage",
          permission: "scheduleManage.*"
        },
        hidden: true
      }
    ]
  },

  //咨询管理
  {
    path: "/qa-management",
    component: Layout,
    name: "qa-management",
    redirect: "/task-management/task-list",
    meta: {
      title: "咨询管理",
      icon: "QAmanagement",
      permission: "QAmanagement.*"
    },
    children: [
      {
        path: "qa-list",
        name: "qa-list",
        component: () => import("@/views/QAmanagement/QAList/index.vue"),
        meta: {
          title: "咨询列表",
          icon: "QAList",
          permission: "QAList.*"
        }
      },
      {
        path: "qa-detail",
        name: "qa-detail",
        component: () => import("@/views/QAmanagement/QAList/detail.vue"),
        meta: {
          title: "咨询详情",
          permission: "QAList.*"
        },
        hidden: true
      },
      {
        path: "qa-configuration",
        name: "qa-configuration",
        component: () =>
          import("@/views/QAmanagement/QAconfiguration/index.vue"),
        meta: {
          title: "咨询配置",
          icon: "QAconfiguration",
          permission: "QAconfiguration.*"
        }
      }
    ]
  },

  // 运营管理
  {
    path: "/operation-management",
    component: Layout,
    name: "operation-management",
    redirect: "/operation-management/promotion-position-config",
    meta: {
      title: "运营管理",
      icon: "operationManagement",
      permission: "operationManagement.*"
    },
    children: [
      {
        path: "promotion-position-config",
        name: "promotion-position-config",
        component: () =>
          import("@/views/miniProgramManage/promotionPositionConfig/index.vue"),
        meta: {
          title: "推广位配置",
          icon: "promotionPositionConfig",
          permission: "promotionPositionConfig.*"
        }
      },
      // 图文导航
      {
        path: "graphic-guide-config",
        name: "graphic-guide-config",
        component: () =>
          import("@/views/miniProgramManage/graphicGuideConfig/index.vue"),
        meta: {
          title: "图文导航配置",
          icon: "graphicGuideConfig",
          permission: "graphicGuideConfig.*"
        }
      },
      // 科室管理
      {
        path: "department-management",
        name: "department-management",
        component: () =>
          import("@/views/mechanismManagement/departmentManagement/index.vue"),
        meta: {
          title: "科室管理",
          icon: "departmentManagement",
          permission: "departmentManagement.*"
        }
      },
      // 标签管理
      {
        path: "tag-manage",
        name: "tag-manage",
        component: () => import("@/views/courseManage/tagManage/index.vue"),
        meta: {
          title: "标签管理",
          icon: "tagManage",
          permission: "tagManage.*"
        }
      },
      // 评估查询
      {
        path: "evaluate-list",
        name: "evaluate-list",
        component: () =>
          import("@/views/evaluateManagement/evaluateList/index.vue"),
        meta: {
          title: "评估查询",
          icon: "evaluateList",
          permission: "evaluateList.*"
        }
      },
      {
        path: "evaluate-detail",
        name: "evaluate-detail",
        component: () =>
          import("@/views/evaluateManagement/evaluateList/detail.vue"),
        meta: {
          title: "评估详情",
          icon: "home",
          permission: "evaluateList.*"
        },
        hidden: true
      },
      {
        path: "complete-form",
        name: "complete-form",
        component: () =>
          import("@/views/evaluateManagement/evaluateList/completeForm.vue"),
        meta: {
          title: "填写量表",
          icon: "home"
        },
        hidden: true
      },
      // 测评建议模板
      {
        path: "suggestion-template",
        name: "suggestion-template",
        component: () =>
          import("@/views/evaluateManagement/suggestionTemplate/index.vue"),
        meta: {
          title: "模板管理",
          icon: "suggestionTemplate",
          permission: "suggestionTemplate.*"
        }
      },
      // 推荐管理
      {
        path: "recommend-management",
        name: "recommend-management",
        component: () =>
          import("@/views/contentManagement/recommendManagement/index.vue"),
        meta: {
          title: "推荐管理",
          icon: "recommend",
          permission: "recommendManagement.*"
        }
      },
      {
        path: "create-recommend",
        name: "create-recommend",
        component: () =>
          import(
            "@/views/contentManagement/recommendManagement/createRecommend.vue"
          ),
        meta: {
          title: "推荐管理",
          icon: "home"
        },
        hidden: true
      },
      // 分发管理
      {
        path: "distribute",
        name: "distribute",
        component: () => import("@/views/formList/distribute/index.vue"),
        meta: {
          title: "量表分发",
          icon: "distribute",
          permission: "distribute.*"
        }
      },
      {
        path: "distribution-history",
        name: "distribution-history",
        component: () =>
          import("@/views/formList/distributionHistory/index.vue"),
        meta: {
          title: "分发历史",
          icon: "home",
          permission: "distributionHistory.*"
        },
        hidden: true
      },

      {
        path: "editor",
        name: "editor",
        meta: {
          title: "",
          icon: "home",
          permission: "platformLibrary.*"
        },
        component: () => import("@/views/formList/editor/index.vue"),
        hidden: true
      },
      {
        path: "evaluation-results",
        name: "evaluation-results",
        meta: {
          title: "测评详情",
          icon: "home"
          // permission: "evaluateList.*"
        },
        component: () => import("@/views/formList/evaluationResults/index.vue"),
        hidden: true
      },
      //内容审核
      {
        path: "content-review",
        name: "content-review",
        component: () =>
          import("@/views/contentManagement/contentReview/index.vue"),
        meta: {
          title: "内容审核",
          icon: "contentReview",
          permission: "contentReview.*"
        }
      },
      {
        path: "graphic-audit-details",
        name: "graphic-audit-details",
        component: () =>
          import(
            "@/views/contentManagement/contentReview/graphicAuditDetails.vue"
          ),
        meta: {
          title: "图文审核",
          icon: "home"
        },
        hidden: true
      },
      {
        path: "video-audit-details",
        name: "video-audit-details",
        component: () =>
          import(
            "@/views/contentManagement/contentReview/videoAuditDetails.vue"
          ),
        meta: {
          title: "视频审核",
          icon: "home"
        },
        hidden: true
      },
      {
        path: "audio-audit-details",
        name: "audio-audit-details",
        component: () =>
          import(
            "@/views/contentManagement/contentReview/audioAuditDetails.vue"
          ),
        meta: {
          title: "音频审核",
          icon: "home"
        },
        hidden: true
      },
      {
        path: "series-courses-details",
        name: "series-courses-details",
        component: () =>
          import(
            "@/views/contentManagement/contentReview/seriesOfCoursesDetails.vue"
          ),
        meta: {
          title: "课程审核",
          icon: "home"
        },
        hidden: true
      }
    ]
  },
  // 平台标准库
  {
    path: "/platform-standard-library",
    component: Layout,
    name: "platform-standard-library",
    redirect: "/platform-standard-library/platform-library",
    meta: {
      title: "平台标准库",
      icon: "platformStandardLibrary",
      permission: "platformStandardLibrary.*"
    },
    children: [
      {
        path: "platform-library",
        name: "platform-library",
        component: () => import("@/views/formList/platformLibrary/index.vue"),
        meta: {
          title: "平台量表库",
          icon: "platformLibrary",
          permission: "platformLibrary.*"
        }
      },
      {
        path: "preview",
        name: "preview",
        component: () =>
          import("@/views/formList/platformLibrary/previewPage.vue"),
        meta: {
          title: "预览",
          icon: "platformLibrary",
          permission: "platformLibrary.*"
        },
        hidden: true
      },
      {
        path: "estimate",
        name: "estimate",
        component: () => import("@/views/formList/estimate/index.vue"),
        meta: {
          title: "设置评估因子",
          icon: "home",
          permission: "estimate.*"
        },
        hidden: true
      },
      {
        path: "group-activity-library",
        name: "group-activity-library",
        component: () =>
          import(
            "@/views/platformStandardLibrary/groupActivityLibrary/index.vue"
          ),
        meta: {
          title: "小组活动库",
          icon: "groupActivityLibrary",
          permission: "groupActivityLibrary.*"
        }
      },
      {
        path: "early-learning-activity-library",
        name: "early-learning-activity-library",
        component: () =>
          import(
            "@/views/platformStandardLibrary/earlyLearningActivityLibrary/index.vue"
          ),
        meta: {
          title: "早期学习活动库",
          icon: "earlyLearningActivityLibrary",
          permission: "earlyLearningActivityLibrary.*"
        }
      },
      {
        path: "problem-intervention-library",
        name: "problem-intervention-library",
        component: () =>
          import(
            "@/views/platformStandardLibrary/problemInterventionLibrary/index.vue"
          ),
        meta: {
          title: "问题干预库",
          icon: "problemInterventionLibrary",
          permission: "problemInterventionLibrary.*"
        }
      },
      {
        path: "intervention-training-library",
        name: "intervention-training-library",
        component: () =>
          import(
            "@/views/platformStandardLibrary/interventionTrainingLibrary/index.vue"
          ),
        meta: {
          title: "干预训练库",
          icon: "interventionTrainingLibrary",
          permission: "interventionTrainingLibrary.*"
        }
      }
    ]
  },
  // 小组活动
  {
    path: "/group-activity",
    component: Layout,
    name: "group-activity",
    redirect: "/group-activity/group-activity-list",
    meta: {
      title: "小组活动",
      icon: "groupActivity",
      permission: "groupActivity.*"
    },
    children: [
      {
        path: "group-activity-list",
        name: "group-activity-list",
        component: () =>
          import("@/views/groupActivity/groupActivityList/index.vue"),
        meta: {
          title: "小组活动列表",
          icon: "groupActivityList",
          permission: "groupActivityList.*"
        }
      },
      {
        path: "early-learning-activity",
        name: "early-learning-activity",
        component: () =>
          import("@/views/groupActivity/earlyLearningActivity/index.vue"),
        meta: {
          title: "早期学习活动",
          icon: "earlyLearningActivity",
          permission: "earlyLearningActivity.*"
        }
      },
      {
        path: "activity-arrangement",
        name: "activity-arrangement",
        component: () =>
          import("@/views/groupActivity/activityArrangement/index.vue"),
        meta: {
          title: "活动安排",
          icon: "activityArrangement",
          permission: "activityArrangement.*"
        }
      }
    ]
  },

  // 照护干预
  {
    path: "/care-intervention",
    component: Layout,
    name: "care-intervention",
    redirect: "/care-intervention/problem-intervention",
    meta: {
      title: "照护干预",
      icon: "careIntervention",
      permission: "careIntervention.*"
    },
    children: [
      {
        path: "problem-intervention",
        name: "problem-intervention",
        component: () =>
          import("@/views/careIntervention/problemIntervention/index.vue"),
        meta: {
          title: "问题干预",
          icon: "problemIntervention",
          permission: "problemIntervention.*"
        }
      },
      {
        path: "intervention-training",
        name: "intervention-training",
        component: () =>
          import("@/views/careIntervention/interventionTraining/index.vue"),
        meta: {
          title: "干预训练",
          icon: "interventionTraining",
          permission: "interventionTraining.*"
        }
      }
    ]
  },

  // 机构管理
  {
    path: "/mechanism-management",
    component: Layout,
    name: "mechanism-management",
    redirect: "/mechanism-management/hospital",
    meta: {
      title: "机构管理",
      icon: "mechanismManagement",
      permission: "mechanismManagement.*"
    },
    children: [
      {
        path: "hospital",
        name: "hospital",
        component: () =>
          import("@/views/mechanismManagement/hospitalManagement/index.vue"),
        meta: {
          title: "医院管理",
          icon: "hospitalManagement",
          permission: "hospitalManagement.*"
        }
      },
      {
        path: "create-hospital",
        name: "create-hospital",
        component: () =>
          import(
            "@/views/mechanismManagement/hospitalManagement/createHospital.vue"
          ),
        meta: {
          title: "创建医院",
          icon: "home"
        },
        hidden: true
      }
    ]
  },

  // 系统配置
  {
    path: "/system-config",
    component: Layout,
    name: "system-config",
    redirect: "/system-config/dictionary",
    meta: {
      title: "系统配置",
      icon: "sys",
      permission: "sys.*"
    },
    children: [
      {
        path: "dictionary",
        name: "dictionary",
        component: () =>
          import("@/views/systemConfig/dictionaryManage/index.vue"),
        meta: {
          title: "字典管理",
          icon: "dictionary",
          permission: "dictionary.*"
        }
      },
      {
        path: "dictionary-second",
        name: "dictionary-second",
        component: () =>
          import("@/views/systemConfig/dictionaryManage/secondPage.vue"),
        meta: {
          title: "字典管理",
          icon: "home"
        },
        hidden: true
      },
      {
        path: "sys-category",
        name: "sys-category",
        component: () => import("@/views/systemConfig/sysCategory/index.vue"),
        meta: {
          title: "系统类目",
          icon: "sysCategory",
          permission: "sysCategory.*"
        }
      },
      {
        path: "sys-second-category",
        name: "sys-second-category",
        component: () =>
          import("@/views/systemConfig/sysCategory/secondCategory.vue"),
        meta: {
          title: "二级类目",
          icon: "home",
          permission: "sysCategory.*"
        },
        hidden: true
      },
      {
        path: "sys-third-category",
        name: "sys-third-category",
        component: () =>
          import("@/views/systemConfig/sysCategory/thirdCategory.vue"),
        meta: {
          title: "三级类目",
          icon: "home",
          permission: "sysCategory.*"
        },
        hidden: true
      },
      {
        path: "resource-manage",
        name: "resource-manage",
        component: () =>
          import("@/views/systemConfig/resourceManage/index.vue"),
        meta: {
          title: "资源管理",
          icon: "resource",
          permission: "resource.*"
        }
      },
      {
        path: "role-manage",
        name: "role-manage",
        component: () => import("@/views/systemConfig/roleManage/index.vue"),
        meta: {
          title: "角色权限",
          icon: "role",
          permission: "role.*"
        }
      },
      {
        path: "employee-manage",
        name: "employee-manage",
        component: () =>
          import("@/views/systemConfig/employeeManage/index.vue"),
        meta: {
          title: "用户管理",
          icon: "employeeManage",
          permission: "employeeManage.*"
        }
      },
      {
        path: "operation-log",
        name: "operation-log",
        component: () => import("@/views/systemConfig/operationLog/index.vue"),
        meta: {
          title: "操作日志",
          icon: "operationLog",
          permission: "operationLog.*"
        }
      }
    ]
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js